<script setup lang="ts">
import { ref } from 'vue'
import { useStore } from '@/core/store'
import router from '@/router'
import SideMenuLink from '@/components/sidemenu/SideMenuLink.vue'
import ExpandableList from '@/components/sidemenu/ExpandableList.vue'

const store = useStore()
const expandMenu = ref(true)

const logout = () => {
  store.logout()
  router.push('/login')
}
</script>

<template>
  <div class="container" :class="{ active: expandMenu }" v-if="store.isAuthenticated">
    <div class="side-menu" :class="{ active: expandMenu }" @click="expandMenu = true">
      <SideMenuLink to="/" icon="home" text="Home" id="home-link" />

      <ExpandableList icon-class="material-icons" icon="linear_scale" text="Spectra" id="spectra-menu" :close="!expandMenu">
        <SideMenuLink to="/spectra" icon-class="material-icons" icon="linear_scale" text="List of spectra" small id="spectra-list-link" />
        <SideMenuLink to="/spectra/import" icon="add" text="Import new spectra" small id="import-spectra-link" />
      </ExpandableList>

      <ExpandableList icon="view_cozy" text="Collections" id="collections-menu" :close="!expandMenu">
        <SideMenuLink to="/collections" icon="view_cozy" text="List of collections" small id="collections-list-link" />
        <SideMenuLink to="/collections/new" icon="add" text="Create collection" small id="create-collections-link" />
      </ExpandableList>

      <SideMenuLink to="/tasks" icon="task" text="List of tasks" id="tasks-list-link" />
      <SideMenuLink to="/files" icon="folder" text="Shared documents" id="files-link" />
      <SideMenuLink to="/servers" icon="storage" text="Remote servers" id="servers-link" />
      <SideMenuLink to="/news" icon="newsmode" text="News" id="news-link" />
      <SideMenuLink to="/versions" icon="bookmarks" text="Versions" id="versions-link" />

      <ExpandableList icon="supervisor_account" text="Users & Roles" id="users-menu" :close="!expandMenu">
        <SideMenuLink to="/users" icon="supervisor_account" text="Users" small id="users-list-link" />
        <SideMenuLink to="/roles" icon="admin_panel_settings" text="Roles" small id="roles-list-link" />
      </ExpandableList>

      <ExpandableList icon="account_box" text="My account" id="account-menu" :close="!expandMenu">
        <SideMenuLink to="/users/edit/:id" icon="person" text="Edit account" small id="my-account-link" />
        <SideMenuLink to="/update-password" icon="key" text="Update password" small id="update-password-link" />
      </ExpandableList>

      <div class="side-menu-item" @click="logout" id="logout-link">
        <span class="material-symbols-outlined">logout</span>
        <span>Logout</span>
      </div>
    </div>

    <div class="expand-menu-arrow" @click="expandMenu = !expandMenu" :class="{ active: expandMenu }" id="expand-menu-arrow">
      <span class="material-symbols-outlined" :class="{ active: expandMenu }">chevron_right</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/styles/sidemenu.scss';
</style>
